export default __webpack_public_path__ + "static/media/featured3.c9a7b031.png";